import styled from 'styled-components'

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp48} 0;
`
